// extracted by mini-css-extract-plugin
module.exports = {"table":"DuplicatesTable_table__1p1QJ","rotate":"DuplicatesTable_rotate__23Ng5"};